
namespace Matrix.Indexation {

    @Serenity.Decorators.registerClass()
    export class DimBasketConstituentDialog extends Serenity.EntityDialog<DimBasketConstituentRow, any> {
        protected getFormKey() { return DimBasketConstituentForm.formKey; }
        protected getIdProperty() { return DimBasketConstituentRow.idProperty; }
        protected getLocalTextPrefix() { return DimBasketConstituentRow.localTextPrefix; }
        protected getService() { return DimBasketConstituentService.baseUrl; }
        protected getDeletePermission() { return DimBasketConstituentRow.deletePermission; }
        protected getInsertPermission() { return DimBasketConstituentRow.insertPermission; }
        protected getUpdatePermission() { return DimBasketConstituentRow.updatePermission; }

        protected form = new DimBasketConstituentForm(this.idPrefix);

    }
}